import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

function SignupSuccess() {
  const [userEmail, setUserEmail] = useState('');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get('email');

    if (email) {
      // setUserEmail(decodeURIComponent(email));
      setUserEmail(email);
    }
  }, [location]);

  return (
    <section className="theme-light section m-0 p-0" data-theme="light">
        <div className='fullHeight m-0 p-0 is-flex is-flex-direction-column is-justify-content-space-between'>
          <div>
            {/* Navigation */}
            <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11 is-offset-1"><Navigation /></div>
            </div>

            {/* Content */}
            <div className='pb-6 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-6">
                <h1 className='pt-4 px-0 pb-0 m-0'>Nice! You're almost in.</h1>
                  <h2 className='py-2 px-0 m-0'>
                  {userEmail ? (
                    <>
                      Your account at <span className='is-bold'>{userEmail}</span> just needs to be confirmed. Check your email and click the button in there to confirm this address. You can do it. We have faith in you.
                    </>
                  ) : (
                    <>
                      Your account just needs to be confirmed. Check your email and click the button in there to confirm this address. You can do it. We have faith in you.
                    </>
                  )}
🙏
                  </h2>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
            <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
          </div>
        </div>
      </section>
  );
}

export default SignupSuccess;
